export default __webpack_public_path__ + "9aaab2eab2952dbc96c28bcc73a900aa.png";